import React from 'react';

import { Tab } from './Tab';

type Props = {
  items: string[];
  index: number;
  onChange: (index: number) => void;
};

export const Tabs: React.FC<Props> = ({ items, index, onChange }) => {
  return (
    <ul className='entity-tab-nav entity-tab-nav--on-dark-background'>
      {items.map((title, itemIndex) => {
        return (
          <Tab
            key={`${title}-${itemIndex}`}
            onSelected={() => onChange(itemIndex)}
            title={title}
            isActive={itemIndex === index}
          />
        );
      })}
    </ul>
  );
};
